import { useSearchParams } from 'react-router-dom';
import { useAppSelector } from '../../../app/hooks';
import { useGetMyProfileQuery } from '../../../services/ProfileService';

export interface MedNecContext {
  company: string;
  center: string;
  centerId: string;
  isConfigured: boolean;
}

export function useMedNecContext(): MedNecContext {
  const [searchParams] = useSearchParams();
  const urlCompany = searchParams.get('company') || '';
  const urlCenter = searchParams.get('center') || '';

  const selectedCenter = useAppSelector(state => state.center.selectedCenter);
  const { data: profile } = useGetMyProfileQuery();
  const fallbackCompany = profile?.organization || '';

  const company = urlCompany || fallbackCompany;
  const center = urlCenter || selectedCenter || '';
  const centerId = `${company}-${center}`;
  const isConfigured = !!company && !!center;

  return { company, center, centerId, isConfigured };
}
